// Round 5c (2026-09-10) · Extracted from Schedule.js so it can be REUSED by
// TodayScheduleList (Home "오늘 방송 예정") without duplicating markup.
// Design and behavior are IDENTICAL to the previous inline component in
// `/app/frontend/src/pages/Schedule.js` (Naver/Kakao EXTERNAL_ONLY brand
// pill, thumbnail, seller, and 원본에서 보기 CTA).  Round 3 "다른 LIVE"
// path is unaffected — that grid still uses HomeLiveCard.
import React from 'react';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { ExternalLink } from 'lucide-react';

const fmtTime = (iso) => {
  try { return format(new Date(iso), 'HH:mm', { locale: ko }); } catch { return ''; }
};

const ExternalScheduleCard = ({ item }) => (
  <a
    href={item.original_url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`ext-live-card-${item.external_id}`}
    className="group flex items-center gap-3 sm:gap-4 p-3 sm:p-4 rounded-2xl bg-white dark:bg-[#141414] border border-black/10 dark:border-white/10 hover:border-[#FF3B30] transition-colors"
  >
    <div className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-xl overflow-hidden bg-gray-100 dark:bg-[#0A0A0A] shrink-0">
      {item.thumbnail_url ? (
        <img src={item.thumbnail_url} alt={item.title} className="w-full h-full object-cover" loading="lazy" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-2xl">📺</div>
      )}
      <span
        className="absolute top-1 left-1 px-1.5 py-0.5 text-[10px] font-bold rounded text-white"
        style={{ backgroundColor: item.brand_color || '#6B7280' }}
        data-testid={`ext-platform-badge-${item.external_id}`}
      >
        {item.platform_name}
      </span>
      {item.status === 'LIVE' && (
        <span className="absolute bottom-1 left-1 px-1.5 py-0.5 text-[10px] font-black rounded bg-[#FF3B30] text-white animate-pulse">
          LIVE
        </span>
      )}
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-1.5 text-[11px] font-bold text-gray-500 dark:text-gray-400 mb-0.5">
        <span className="px-1.5 py-0.5 rounded bg-black/5 dark:bg-white/5" data-testid={`ext-source-badge-${item.external_id}`}>외부</span>
        <span>{fmtTime(item.scheduled_at)}</span>
        {item.seller_name && <span className="truncate max-w-[100px]">· {item.seller_name}</span>}
      </div>
      <h3 className="text-sm sm:text-base font-bold text-gray-900 dark:text-white truncate group-hover:text-[#FF3B30]">
        {item.title}
      </h3>
      {item.product_name && (
        <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{item.product_name}</p>
      )}
    </div>
    <div className="flex items-center gap-1 text-xs font-bold text-[#FF3B30] shrink-0">
      <span className="hidden sm:inline">{item.cta_label || '원본에서 보기'}</span>
      <ExternalLink size={14} />
    </div>
  </a>
);

// Round 5c · Simple mock/test broadcast filter reused by TodayScheduleList
// and future consumer surfaces.  Only user-facing queries call this — DB
// rows and admin surfaces stay untouched.
const MOCK_PATTERNS = [
  /step\s*6[- ]?voice/i,   // "STEP 6-VOICE-G E2E"
  /voice[- ]?g/i,
  /\bT\d+\b/,              // T3, T9, T12, …
  /\btest\b/i,
  /\bdemo\b/i,
  /\bmock\b/i,
  /테스트/,
];
export function isMockExternalRow(row) {
  const hay = ((row?.title || '') + ' ' + (row?.seller_name || '') + ' ' + (row?.product_name || '')).trim();
  if (!hay) return false;
  return MOCK_PATTERNS.some((r) => r.test(hay));
}

export default ExternalScheduleCard;
